// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import Common from "../Common";
import LinkedRoom from "../LinkedRoom";
import Status from "src/components/Unifize/Status/Standard";
import { getChatroomAddress } from "src/reducers";
import type { Message, ChatroomAddress } from "src/types";
import { COMPLETED } from "src/constants/status";

type Props = {
  message: Message,
  address: ChatroomAddress,
};

const Complete = ({ message, address }: Props) => {
  const { data, roomId } = message;
  const { id, comment } = data;
  const isCurrentRoom = id === parseInt(roomId, 10);
  if (isCurrentRoom)
    return (
      <Common {...message} comment={comment}>
        {" "}
        {i18n.t(k.COMPLETED_THIS_CONVERSATION)}
        <Status id={COMPLETED} />
      </Common>
    );

  return (
    <Common {...message} comment={comment}>
      {" "}
      {i18n.t(k.COMPLETED3)} <LinkedRoom id={id} chatroomAddress={address} />
      <Status id={COMPLETED} />
    </Common>
  );
};

const mapStateToProps = ({ app }, { message }) => ({
  address: getChatroomAddress(app, message.data.id),
});

export default connect(mapStateToProps)(Complete);
